import extend from 'extend'
import en from './en'

const message = {
  _common: {
    seq: '번호',
    name: '이름',
    email: '이메일',
    avatar: '아바타',
    joinedDate: '가입일',
    updatedDate: '변경일',
    type: '유형',
    groups: '그룹',
    roles: '역할',
    action: '도구',
    id: '아이디',
    createdDate: '생성일',
    cancel: '취소',
    save: '저장',
    remove: '삭제',
    confirmRemove: '정말 삭제하시겠습니까',
    cost: '비용',
    month: '기준월',
    account: '계정',
    invoiceMonth: '청구월',
    totalCost: '총비용',
    no: '번호',
    invoice: '인보이스',
    report: '리포트',
    country: '국가',
    date: '날짜',
    close: '닫기',
    product: '제품',
    credit: '크레딧',
    reload: '새로 고침',
    ok: '확인',
    project: '프로젝트',
    service: '서비스',
    noData: '데이터 없음',
    startDate: '시작일',
    endDate: '종료일',
    term: '기간',
    discount: '할인',
    total: '합계',
    company: '회사',
    originalCost: '원래 비용',
    finalCost: '최종 비용',
    vat: '부가가치세',
    exchangeRate: '환율',
    undo: '해제',
    workerComplete: '실행서비스 완료',
    viewerComplete: '데이타 업데이트',
    transfer: '이동',
    download: '다운로드',
    cc: '참조',
    usage: '사용량',
    usageUnit: '사용 단위',
    allProjects: '프로젝트 전체',
    currency: '화폐',
    region: '리전',
    logout: '로그아웃',
    mzAccount: '메가존 팝스',
    freeTier: '무료 등급',
    sustainedUsageDiscount: '지속 사용 할인',
    committedUsageDiscount: '약정 사용 할인',
    spendingBasedDiscount: '지출 기반 할인',
    subscriptionBenefitDiscount: '장기 구독 할인',
    promotion: '프로모션',
    applyDiscount: '할인 적용',
    pin_max: '핀은 최대 5개 지정할 수 있습니다.',
    pin_exist: '이 계정은 이미 고정되어 있습니다.',
    language: '언어',
    appearance: '화면 모드',
    light: '라이트 모드',
    dark: '다크 모드',
    auto: '자동',
    searchBy: '검색 항목 - ',
    projectName: '프로젝트명',
    en: '영어',
    ko: '한국어',
    megazone: '메가존',
    megazoneSoft: '메가존소프트',
    megazoneCloud: '메가존클라우드',
    add: '추가',
    dataIsEmpty: '데이터가 없습니다.',
    corporateCategory: '법인 분류',
    international: 'International',
    china: 'China',
    hongkong: 'HongKong',
    australia: 'Australia',
    all: '전체',
    includingRi: 'RI 포함',
  },

  accountText: {
    customer: {
      account: '고객',
      accountsSummary: '고객 요약',
      accountNotify: '선택한 고객의 최종 비용입니다.',
    },
    tenancy: {
      account: '테넌시',
      accountsSummary: '테넌시 요약',
      accountNotify: '선택한 테넌시의 최종 비용입니다.',
    },
  },

  projectText: {
    subscription: {
      project: '구독',
      allProjects: '구독 전체',
      costByProject: '구독별 비용',
      projectName: '구독명',
      projectId: '구독 아이디',
    },
    compartment: {
      project: '부문',
      allProjects: '부문 전체',
      costByProject: '부문별 비용',
      projectName: '부문명',
      projectId: '부문 아이디',
    },
  },

  menu: {
    billing: '과금',
    summary: '요약 정보',
    dataTransfer: '데이터 전송',
    costPivot: '비용 피벗',
    costPivotBq: '비용 피벗',
    costAllocationTags: '비용 할당 태그',
    cdn: 'CDN',
    personal: '사용자 정보',
    profile: '프로필',
    admin: '관리',
    usageDetail: '상세 사용내역',
    alarm: '알람',
    consolidated: '통합',
    commitmentAnalysis: '약정 분석',
    costTrend: '비용 트렌드',
    ipAccessControl: 'IP 접근 제한',
    costTable: '비용 테이블',
  },

  billing: {
    summary: {
      costByCountry: '국가별 비용',
      costByProject: '프로젝트별 비용',
      costByService: '서비스별 비용',
      costByRegion: '리전별 비용',
      dailyCost: '일별 비용',
      stackedCost: '일별 누적 비용',
      forecastCost: '예상 비용',
      forecast: '예상',
      detailInfo: '세부 정보',
      project: '@:_common.project',
      undo: '@:_common.undo',
      promotionCredit: '프로모션 크레딧',
      originalAmount: '원래 양',
      remainAmount: '남은 양',
      more: '더보기',
      allPromotionCredits: '전체 프로모션 크레딧',
      expiredAt: '만료일',
      expiredCheck: '만료',
      accountBalance: '계정 잔액',
      balance: '잔액',
    },

    costPivot: {
      preset: '프리셋',
      clearPreset: '해제',
      saveAs: '추가',
      empty: '없음',
      removePreset: '설정 제거',
      duplicate: '중복된 이름',
      download: '다운로드',
      oneMonth: '일 개월',
      threeMonths: '삼 개월',
      range: '직접 입력',
      startdate: '시작일',
      enddate: '마감일',
      showTag: '태그 항목 보기',
      load: '불러오기',
    },

    dataTransfer: {
      internetEgress: '인터넷 발신',
      from: '출발지',
      to: '목적지',
      traffic: '트래픽',
      internetIngress: '인터넷 수신',
      interRegionEgress: '지역간 발신',
      interRegionIngress: '지역간 수신',
      vpnInternetEgress: 'VPN 인터넷 발신',
      vpnInterRegionEgress: 'VPN 지역간 발신',
      vpnInterRegionIngress: 'VPN 지역간 수신',
    },

    costAllocationTags: {
      costTags: '태그별 사용비용',
      cost: '@:_common.cost',
      date: '@:_common.date',
      tag: '태그',
      credit: '크레딧',
      finalcost: '최종 금액',
    },

    cdn: {
      usage: '사용량',
    },

    invoice: {
      downloadUsage: '사용내역 다운로드',
      viewInvoice: '인보이스 보기',
      viewUsage: '사용내역 보기',
      viewReport: '리포트 보기',
      month: '월',
    },

    invoiceDetail: {
      gcpInvoiceNo: 'GCP 인보이스 번호',
      overview: '개요',
      projectId: '프로젝트 아이디',
      projectName: '프로젝트명',
      service: '서비스',
      startDate: '사용 시작일',
      endDate: '사용 종료일',
      serviceId: '서비스 아이디',
      serviceName: '서비스명',
      type: '타입',
    },

    alarm: {
      name: '알람명',
      addPromotionCredit: '프로모션 크레딧 알람 추가',
      addAccountBalance: '계정 잔액 알람 추가',
      addBudget: '예산 알람 추가',
      modifyAlarm: '수정',
      removeAlarm: '삭제',
      promotionCredit: '프로모션 크레딧',
      remark: '@:_common.remark',
      action: '@:_common.action',
      confirmRemove: '@:_common.confirmRemove',
      type: '@:_common.type',
      setting: '알림 기준 설정',
      totalCredit: '총 크레딧',
      totalBalance: '총 잔액',
      usageCredit: '사용 크레딧',
      usageBalance: '사용 잔액',
      targetAmount: '타겟 금액',
      targetName: '타겟명',
      creditName: '크레딧명',
      balanceName: '잔액명',
      projectName: '프로젝트명',
      serviceName: '서비스명',
      budgetType: '예산 유형',
      specifiedAmount: '지정한 금액',
      lastMonthSpend: '지난달 지출 금액',
      allProjects: '전체 프로젝트',
      allServices: '전체 서비스',
      budgetDescription:
        '월 예산 금액을 설정해 주세요. 예산은 해당하는 월의 1일에 시작되고 매월 초에 재설정됩니다.',
      specifiedAmountDescription: '지출하는 고정 금액과 비교합니다.',
      lastMonthSpendDescription:
        '지난 달 지출 금액을 기준으로 매월 업데이트되는 금액입니다.',
      creditSettingDescription:
        '사용한 크레딧이 전체 크레딧의 일정 비율이나 지정된 크레딧을 초과하면 사용자에게 이메일이 발송됩니다.',
      balanceSettingDescription:
        '현재 잔액이 일정 비율이나 지정된 잔액 이하로 내려가면 사용자에게 이메일이 발송됩니다.',
      budgetSettingDescription:
        '지출 금액이 예산의 일정 비율이나 지정된 금액을 초과하면 사용자에게 이메일이 발송됩니다.',
    },

    consolidated: {
      group: '그룹',
      thisMonthCost: '이번 달 비용',
      lastMonthCost: '지난 달 비용',
      accountsSummary: '계정 요약',
      dailyCost: '일별 비용',
      monthlyCost: '월별 비용',
      ratio: '비율',
      costByService: '서비스별 비용',
      costByRegion: '리전별 비용',
      costByCountry: '국가별 비용',
      serviceName: '서비스명',
      regionName: '리전명',
      searchBy: '검색 항목 - ',
      account: '계정',
      accountNotify: '선택한 계정의 최종 비용입니다.',
      forecastCost: '예상 비용',
      forecast: '예상',
      forecastAdditionalCost: '예상 추가 비용',
    },

    commitmentAnalysis: {
      commitmentType: '약정 타입',
      title: '약정 및 평균 사용량',
      allRegions: '전체 리전',
      allProjects: '전체 프로젝트',
      activeCommitments: '활성 상태인 약정',
      commitmentUtilization: '약정 사용량',
      none: '없음',
      commitmentDesc: '약정 및 사용률',
      averagePerMicrosecond: '마이크로초당 평균',
      usage: '사용량',
      activeCommitment: '활성 상태인 약정',
      utilizedCommitment: '사용된 약정',
      unUtilizedCommitment: '사용되지 않은 약정',
      allUsage: '모든 사용량',
      commitmentUsage: '약정이 적용되는 사용량',
      ondemandUsage: '요건을 충족하는 주문형 사용량',
      highlights: '하이라이트',
      load: '불러오기',
    },

    costTrend: {
      variance: '비용 변동폭',
      costByProject: '프로젝트별 비용',
      costBySku: '제품별 비용',
      sku: '제품',
      skuName: '제품명',
      apply: '적용',
      columnChart: '막대 차트',
      lineChart: '라인 차트',
    },

    costTable: {
      projectId: '프로젝트 아이디',
      serviceId: '서비스 아이디',
      skuId: '제품 아이디',
      locationCountry: '로케이션/국가',
      zone: '존',
      costType: '비용 타입',
      usageUnit: '사용 단위',
      usageDate: '사용 날짜',
      usage: '사용량',
      finalCost: '최종 비용',
      tSystemMachineSpec: '시스템 기계 사양',
      tSystemCores: '시스템 코어',
      tSystemMemory: '시스템 메모리',
      freeTier: '무료 등급',
      sustainedUsageDiscount: '지속 사용 할인',
      committedUsageDiscount: '약정 사용 할인',
      spendingBasedDiscount: '지출 기반 할인',
      promotion: '프로모션',
      currencyConversionRate: '환율',
      oneMonth: '일 개월',
      threeMonths: '삼 개월',
      sixMonths: '육 개월',
      oneYear: '일 년',
      range: '직접 입력',
      reset: '초기화',
      project: '프로젝트',
      service: '서비스',
      serviceName: '서비스명',
      sku: '제품',
      skuName: '제품명',
      projectName: '프로젝트명',
      searchBy: '검색 항목',
    },
  },

  personal: {
    profile: {},
    ipRestrictions: {
      description: '설명',
      allowAllIP: '모든 IP 허용',
      addAllowedIp: '허용 IP 추가',
      modifyAllowedIp: '허용 IP 수정',
      removeAllowedIp: '허용 IP 삭제',
      example: '예시',
      or: '또는',
    },
  },

  admin: {
    searchField: {
      searchBy: '검색 항목 - ',
    },
  },

  material: {
    days: [
      '일요일',
      '월요일',
      '화요일',
      '수요일',
      '목요일',
      '금요일',
      '토요일',
    ],
    shortDays: ['일', '월', '화', '수', '목', '금', '토'],
    shorterDays: ['일', '월', '화', '수', '목', '금', '토'],
    months: [
      '1월',
      '2월',
      '3월',
      '4월',
      '5월',
      '6월',
      '7월',
      '8월',
      '9월',
      '10월',
      '11월',
      '12월',
    ],
    shortMonths: [
      '1월',
      '2월',
      '3월',
      '4월',
      '5월',
      '6월',
      '7월',
      '8월',
      '9월',
      '10월',
      '11월',
      '12월',
    ],
    shorterMonths: [
      '1',
      '2',
      '3',
      '4',
      '5',
      '6',
      '7',
      '8',
      '9',
      '10',
      '11',
      '12',
    ],
  },

  error: {
    message: {
      404: '찾을 수 없는 페이지 입니다.',
      403: '유저 등록이 되어 있지 않아 접근 권한이 없습니다. 관리자에게 인증한 이메일을 등록 문의해주세요.',
      4036: 'IP 주소가 거부되었습니다. 관리자에게 문의해주세요.',
    },
    redirectButton: '홈으로',
  },
}

export default extend(true, {}, en, message)
